export const version = "signing-key/5.0.7";
//# sourceMappingURL=_version.js.map